import { http, HttpResponse } from 'msw';

import type { IApiAuthorizeResponseBody } from './AuthApi.types';

export const getApiAuthorizeHandler = http.get<
  never,
  null,
  IApiAuthorizeResponseBody
>('https://api/authorize', () =>
  HttpResponse.json<IApiAuthorizeResponseBody>({
    message: 'ok',
  }),
);
